import { updateLoadingEffect } from './updateLoadingEffect';

/**
 * Funkce pro aktualizaci statistik sázení pro Tipsport sázky ve vybraném zápase.
 * Pokud jsou k dispozici kurzové sázky, jejich hodnoty se aktualizují na stránce.
 * Pokud status zápasu je 'fin' (zapas ukončen), obalovací element pro sázky je skryt.
 *
 * @param matchElement - HTMLElement zápasu, který má být aktualizován.
 * @param matchStatus - Stav zápasu.
 * @param tipsportCourses - Kurzy pro sázky na zápas.
 */
export const updateMatchBetStatistics = (
  matchElement: HTMLElement,
  matchStatus: string,
  tipsportCourses: any
) => {
  const matchBetStatisticsWrapper = matchElement.querySelector<HTMLElement>(
    '[data-match-overview-match-bet-statistics]'
  );

  if (!tipsportCourses || !matchBetStatisticsWrapper) return;

  const betSport = matchElement.getAttribute('data-match-sport');
  const tipsportMatchBetStatistics = tipsportCourses.bets_percentage;

  if (tipsportMatchBetStatistics) {
    // zobrazení statistik pokud existuju data
    matchBetStatisticsWrapper.classList.add('detail-match-overview-bet__statistics--active');

    const homeWinCourse =
      matchBetStatisticsWrapper.querySelector<HTMLElement>('[data-match-home-win]');
    const drawCourse = matchBetStatisticsWrapper.querySelector<HTMLElement>('[data-match-draw]');
    const awayWinCourse =
      matchBetStatisticsWrapper.querySelector<HTMLElement>('[data-match-away-win]');

    if (homeWinCourse && homeWinCourse.textContent !== tipsportMatchBetStatistics.home_win) {
      homeWinCourse.textContent = tipsportMatchBetStatistics.home_win;
      updateLoadingEffect(homeWinCourse);
    }
    if (
      drawCourse &&
      drawCourse.textContent !== tipsportMatchBetStatistics.draw_course &&
      betSport !== 'ten'
    ) {
      drawCourse.textContent = tipsportMatchBetStatistics.draw;
      updateLoadingEffect(drawCourse);
    }
    if (awayWinCourse && awayWinCourse.textContent !== tipsportMatchBetStatistics.away_win) {
      awayWinCourse.textContent = tipsportMatchBetStatistics.away_win;
      updateLoadingEffect(awayWinCourse);
    }
  }

  if (['live', 'fin', 'retired'].includes(matchStatus)) {
    matchBetStatisticsWrapper.textContent = '';
    matchBetStatisticsWrapper.style.display = 'none';
  }
};
